module.exports = __webpack_public_path__ + "img/bg4.ef399925.png";